'use client';

import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const CloneButton = styled.div<{ $hideMobile?: boolean }>`
  @media (max-width: ${breakPoints.mobilePortrait}) {
    display: ${(props) => (props.$hideMobile ? 'none' : 'inherit')};
  }
  .clone-menu {
    background-color: pink;
  }
`;

export const CloneContent = styled.div`
  min-width: 400px;
  min-height: 100px;
  background-color: ${colors.secondary.lightGray1};
  padding: 10px;
  border-radius: 4px;
`;

// export const Popover = styled.div`
//   position: relative;
//   z-index: 99;
//   .PopoverContent {
//     min-width: 400px;
//     min-height: 100px;
//     background-color: ${colors.secondary.lightGray1};
//     padding: 10px;
//     border: 1px solid ${colors.secondary.lightGray3};
//     border-radius: 4px;
//     box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
//   }

//   .PopoverArrow {
//     fill: ${colors.secondary.lightGray3};
//     /* stroke: ${colors.secondary.lightGray3}; */
//   }
// `;

export const CodeSection = styled.div<{ $copied: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  .copy-indicator {
    color: ${({ $copied }) => ($copied ? colors.semantic.positive.primary : 'inherit')};
  }
  .hint {
    padding-left: 5px;
    font-size: 12px;
  }
`;
